const getWindowLocation = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const location = window.location;

  if (!location || typeof location.pathname !== "string") {
    return null;
  }

  return location;
};

const getWindowPath = () => {
  const location = getWindowLocation();

  if (!location) {
    return null;
  }

  return `${location.pathname}${location.search}`;
};

let initialWebPath: null | string = null;

export const isValidPreAuthenticationPath = (
  path?: null | string
): path is string => {
  if (!path) {
    return false;
  }

  // Single-use account links must not become automatic post-login destinations.
  return (
    path !== "/patron" &&
    !path.includes("/login") &&
    !/^\/patron\/(?:reset-password|register)(?:[/?#]|$)/.test(path)
  );
};

export const getWebPreAuthenticationPath = () => {
  const currentPath = getWindowPath();

  if (isValidPreAuthenticationPath(currentPath)) {
    if (!initialWebPath) {
      initialWebPath = currentPath;
    }

    return currentPath;
  }

  if (!initialWebPath) {
    initialWebPath = getWindowPath();
  }

  if (isValidPreAuthenticationPath(initialWebPath)) {
    return initialWebPath;
  }

  return null;
};
